import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

import { SHOW_NETWORK_PANEL } from 'src/environments/runtime';

import { SystemReadyService } from './shared/components/system-ready/system-ready.service';
import { ThemeService } from './shared/services/theme/theme.service';
import { TranslationManagerService } from './shared/services/translation-manager/translation-manager.service';
import { setSessionActive } from './stores/global';
import { loadSettings, selectSettingIsLoaded } from './stores/settings';
import { loadSpaces } from './stores/spaces';

@Component({
  selector: 'frodo-root',
  templateUrl: './app.component.html',
})
export class AppComponent implements OnInit {
  isSettingsLoaded = this.store.select(selectSettingIsLoaded);
  showNetworkPanel: boolean;

  constructor(
    private translationManagerService: TranslationManagerService,
    private store: Store,
    private themeService: ThemeService,
    private systemReadyService: SystemReadyService
  ) {
    this.showNetworkPanel = (SHOW_NETWORK_PANEL as unknown as string) === 'true' ? true : false;
  }

  ngOnInit() {
    this.store.dispatch(loadSettings());
    this.systemReadyService.initSettingsRetry();
    this.store.dispatch(loadSpaces());
    this.store.dispatch(setSessionActive({ value: false }));
    this.isSettingsLoaded.subscribe((isLoaded) => {
      if (isLoaded) {
        this.themeService.initTheme();
        this.translationManagerService.initSettings();
      }
    });
  }
}
